<template>
  <v-dialog :persistent="isLoading" :value="openDialog" max-width="400" @input="$emit('update:open-dialog', $event)">
    <v-card flat :loading="isLoading">
      <div class="pa-7">
        <div class="d-flex align-center u-width-100">
          <div class="u-label-2">{{ title }}</div>
        </div>

        <div class="u-body-2 mt-3" v-html="message"></div>

        <v-divider class="mt-4" light />

        <div class="d-flex justify-end mt-2">
          <div class="u-simple-pseudo-link u-label-1 darkGrey--text" @click="$emit('click:cancel')">
            {{ cancelText }}
          </div>
          <div class="u-simple-pseudo-link u-label-1 ml-4 red--text" @click="$emit('click:confirm')">
            {{ confirmText }}
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    openDialog: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    cancelText: {
      type: String,
      default: '',
    },
    confirmText: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
  },
}
</script>
